import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { GlobalBannerService } from './global-banner.service';
import { MapService } from './map.service';
import { ThemeService } from './theme.service';
import { GlobalBannerComponent } from './ui/global-banner/global-banner.component';
import { InfoContainerComponent } from './ui/info-container/info-container.component';
import { LegendsComponent } from './ui/legends/legends.component';
import { LocateUserButtonComponent } from './ui/locate-user-button/locate-user-button.component';
import { MapComponent } from './ui/map/map.component';
import { SearchComponent } from './ui/search/search.component';
import { ZoomButtonsComponent } from './ui/zoom-buttons/zoom-buttons.component';

@Component({
  selector: 'app-root',
  imports: [
    GlobalBannerComponent,
    InfoContainerComponent,
    LegendsComponent,
    LocateUserButtonComponent,
    MapComponent,
    SearchComponent,
    ZoomButtonsComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppComponent {
  isLoading = inject(MapService).isLoading;
  themeService = inject(ThemeService);
  globalBannerService = inject(GlobalBannerService);
}
